const TENANT_COM = 'com'
const TENANT_AT = 'at'
const TENANT_CH = 'ch'
const TENANT_ES = 'es'
const TENANT_FR = 'fr'
const TENANT_IT = 'it'
const TENANT_BASE = 'base'
const TENANT_TEST = 'test'
const TENANT_COM_QS = 'com-qs'

module.exports = {
  TENANT_COM,
  TENANT_AT,
  TENANT_CH,
  TENANT_ES,
  TENANT_FR,
  TENANT_IT,
  TENANT_BASE,
  TENANT_TEST,
  TENANT_COM_QS,
}
